import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Empregador, JornadaPonto } from '../../api.service';
import { RodapeCrudComponent } from '../../shared/rodape-crud.component';
import { ServicoMensagemAplicacao } from '../../shared/servico-mensagem-aplicacao';
import { GradeHorariosJornadaComponent } from './grade-horarios-jornada.component';
import { GradeJornadasRelogioComponent } from './grade-jornadas-relogio.component';
import { PainelDadosJornadaComponent } from './painel-dados-jornada.component';
import { ServicoRelogioPonto } from './servico-relogio-ponto';

@Component({
  selector: 'app-painel-jornadas-relogio',
  standalone: true,
  imports: [
    CommonModule,
    GradeHorariosJornadaComponent,
    GradeJornadasRelogioComponent,
    PainelDadosJornadaComponent,
    RodapeCrudComponent
  ],
  templateUrl: './painel-jornadas-relogio.component.html'
})
export class PainelJornadasRelogioComponent {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';
  @Input({ required: true }) jornada!: JornadaPonto;
  @Input() jornadas: JornadaPonto[] = [];

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() alterarEmpregador = new EventEmitter<void>();
  @Output() mensagem = new EventEmitter<string>();
  @Output() jornadaSalva = new EventEmitter<JornadaPonto>();
  @Output() jornadaLimpa = new EventEmitter<JornadaPonto>();
  @Output() jornadaExcluida = new EventEmitter<void>();

  constructor(
    private readonly servicoMensagemAplicacao: ServicoMensagemAplicacao,
    private readonly servicoRelogioPonto: ServicoRelogioPonto
  ) {}

  selecionarEmpregador(empregadorId: string) {
    this.empregadorSelecionadoChange.emit(empregadorId);
    this.alterarEmpregador.emit();
  }

  selecionarJornada(jornadaId: string) {
    this.jornada = this.servicoRelogioPonto.selecionarJornada(this.jornadas, jornadaId, this.empregadorSelecionado);
    this.jornadaLimpa.emit(this.jornada);
  }

  adicionarHorario() {
    this.jornada = this.servicoRelogioPonto.adicionarHorario(this.jornada);
    this.jornadaLimpa.emit(this.jornada);
  }

  removerHorario(indice: number) {
    this.jornada = this.servicoRelogioPonto.removerHorario(this.jornada, indice);
    this.jornadaLimpa.emit(this.jornada);
  }

  limparJornada() {
    this.jornada = this.servicoRelogioPonto.novaJornada(this.empregadorSelecionado);
    this.jornadaLimpa.emit(this.jornada);
  }

  salvarJornada() {
    if (!this.empregadorSelecionado) {
      this.mensagem.emit(this.servicoRelogioPonto.mensagemEmpregadorObrigatorioJornada());
      return;
    }
    this.jornada.empregadorId = this.empregadorSelecionado;
    const editando = !!this.jornada.id;
    this.servicoRelogioPonto.salvarJornada(this.jornada).subscribe({
      next: salvo => {
        this.mensagem.emit(this.servicoMensagemAplicacao.registroSalvo(editando));
        this.jornada = this.servicoRelogioPonto.prepararJornada(salvo);
        this.jornadaSalva.emit(salvo);
      },
      error: () => this.mensagem.emit(this.servicoRelogioPonto.mensagemErroSalvarJornada())
    });
  }

  excluirJornada() {
    if (!this.jornada.id || this.jornada.padrao || !window.confirm(this.servicoRelogioPonto.mensagemConfirmarExclusaoJornada(this.jornada))) {
      return;
    }
    this.servicoRelogioPonto.excluirJornada(this.jornada.id).subscribe({
      next: () => {
        this.mensagem.emit(this.servicoMensagemAplicacao.registroExcluido());
        this.jornada = this.servicoRelogioPonto.novaJornada(this.empregadorSelecionado);
        this.jornadaExcluida.emit();
      },
      error: () => this.mensagem.emit(this.servicoRelogioPonto.mensagemErroExcluirJornada())
    });
  }
}
